export default __webpack_public_path__ + "static/media/illustration-work-2-w@3x.5c0a5dfe.png";